import { render } from "./AllCharteredAccountant.vue?vue&type=template&id=97b8afc2"
import script from "./AllCharteredAccountant.vue?vue&type=script&lang=js"
export * from "./AllCharteredAccountant.vue?vue&type=script&lang=js"

import "./AllCharteredAccountant.vue?vue&type=style&index=0&id=97b8afc2&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__